import { createSlice } from "@reduxjs/toolkit";
import { uploadedDoctorDocument } from "../../reducer/uploadedDoctorDocuments/uploadedDocReducer";

import i18n from "../../i18n";
//default value
const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const doctorDocumentsSlice = createSlice({
  name: "doctorDocuments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadedDoctorDocument.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(uploadedDoctorDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(uploadedDoctorDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || action.error?.message || i18n.t("common.errorOccurred");
        state.data = {};
      });
  },
});

export default doctorDocumentsSlice.reducer;
